import React, {useState, useEffect} from 'react'
import {toAbsoluteUrl, KTIcon} from '../../../../_metronic/helpers'
import {IProfileDetails} from './SettingsModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {TableBox} from './TableBox'
import {TotalBill} from './TotalBill'
const profileDetailsSchema = Yup.object().shape({
  fName: Yup.string().required('First name is required'),
  lName: Yup.string().required('Last name is required'),
  code: Yup.string().required('code is required'),
  contactPhone: Yup.string().required('Contact phone is required'),
})

export function Detail(props: any) {
  const navigate = useNavigate()
  const API_URL = process.env.REACT_APP_API_URL
  const initialValues: any = {
    fName: props.firstname,
    lName: props.lastname,
    contactPhone: props.mobile_number,
    code: props.code,
    address: '',
    email: '',
  }
  const [data, setData] = useState<any>({
    burnEarnPurchase: {
      earn: 0,
      burn: 0,
      purchase: 0,
    },
    transaction: [],
    redeemHistory: [],
  })
  const updateData = (fieldsToUpdate:any) => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }
  const AlertError = (message: string) => {
    Swal.fire('', message, 'error')
  }

  useEffect(
    () => {
      //getAPI()
      //console.log('props', props, props[0]['code'])
      console.log('propscc', props.props)
      setData({
        burnEarnPurchase: props.props.burnEarnPurchase,
        transaction: props.props.transaction,
        redeemHistory: props.props.redeemHistory,
      })
      console.log(data)
    },
    [] // Only re-call effect if value or delay changes
  )

  const uploadImage = async (e: any) => {
    if (e.target.files.length) {
      e.preventDefault()
      var _URL = window.URL || window.webkitURL
      var file = e.target.files[0]
      var formdata = new FormData()
      formdata.append('image', file)
      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow',
      }
      const data = await axios.post(`${API_URL}/upload`, formdata)
    }
  }

  const [loading, setLoading] = useState(false)

  return (
    <div className='mb-5 mb-xl-10'>
      {/*<div
        className='card-header border-0 cursor-pointer'
        role='button'
        //data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Profile Details</h3>
        </div>
      </div>*/}
      <br />
      <div></div>
      <div className='mb-5 row'>
        <div style={{width: '50px'}}></div>
        <div className='mb-5 col-xl-2'>
          <div className='border border-success border-dashed rounded min-w-100px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <i className='fas fa-arrow-trend-up fa-1x text-success'></i>
              <div className='fs-2 fw-bolder m-2'>earn point</div>
            </div>
            {Number(props.props.burnEarnPurchase.earn).toFixed(0)}
            <div className='fontSize16 fw-bold fs-6 text-gray-800 mt-3'>
            </div>
          </div>
        </div>
        <div className='mb-5 col-xl-2'>
          <div className='border border-danger border-dashed rounded min-w-100px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <i className='fas fa-fire fs-2x text-danger'></i>
              <div className='fs-2 fw-bolder m-2'>burn point</div>
            </div>
            {Number(props.props.burnEarnPurchase.burn).toFixed(0)}
            <div className='fontSize16 fw-bold fs-6 text-gray-800 mt-3'>
            </div>
          </div>
        </div>
        <div className='mb-5 col-xl-2'>
          <div className='border border-warning border-dashed rounded min-w-100px py-3 px-4 me-6 mb-3'>
            <div className='d-flex align-items-center'>
              <i className='fas fa-money-check-dollar fs-2x text-warning'></i>
              <div className='fs-2 fw-bolder m-2'>Purchase</div>
            </div>
            {Number(props.props.burnEarnPurchase.purchase).toFixed(0)}
            <div className='fontSize16 fw-bold fs-6 text-gray-800 mt-3'>
            </div>
          </div>
        </div>
      </div>
      <div className='mb-5 row'>
        <div className='col-xl-6'>
          <TableBox
            className='card-xxl-stretch mb-5 mb-xl-8'
            data={props.props.transaction}
            header={['สินค้า', 'ราคา (บาท)', 'ซื้อเมื่อ']}
            text='รายการสั่งซื้อ'
          />
        </div>
        <div className='col-xl-6'>
          <TableBox
            className='card-xxl-stretch mb-5 mb-xl-8'
            data={props.props.redeemHistory}
            header={['รางวัล', 'ใช้กี่คะแนน', 'แลกเมื่อ']}
            text='รายการแลกรางวัล'
          />
        </div>
      </div>
    </div>
  )
}

//export {Detail}
